module.exports = __webpack_public_path__ + "static/img/MoorePeter_BrechtGeorge_DouglassCollege_1963.c360dc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/MoorePeter_BrechtGeorge_DouglassCollege_1963.jpg
// module id = oDpo
// module chunks = 0